import React, { useEffect } from 'react'
import "./SectionAbout.scss"
import Aos from 'aos'
const SectionAbout = ({t}) => {

  useEffect(() => {
    Aos.init({
      duration: 1000
    });
  }, []);
  return (
    <section className="section-about">
        <div className="content" data-aos="fade-up">
            {/* <h1 className="title-about" data-aos="flip-left" >
                {t.ABoutMerse}
            </h1> */}
            <p className="paragraph-about" data-aos="fade-right">
                {t.sectionAboutParagraph}
            </p>
        </div>
    </section>
  )
}

export default SectionAbout